export const isQuarter = segmentation => segmentation === 'Quarter';
